module.exports = __webpack_public_path__ + "static/media/portfolio_5.6aa29d05.jpeg";